module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dialogues"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "senor-and-chullo"
    }
  }, [_c('h2', [_vm._v("Senor and Chullo")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "98%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "4%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "header"
  }, [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_vm._v("S=Senor C=Chullo")])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("S:")]), _vm._v(" "), _c('td', [_vm._v("What a great day, Chullo!")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("C:")]), _vm._v(" "), _c('td', [_vm._v("Yes, Senor.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("S:")]), _vm._v(" "), _c('td', [_vm._v("Chullo, where are you?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("C:")]), _vm._v(" "), _c('td', [_vm._v("Here, Senor.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("S:")]), _vm._v(" "), _c('td', [_vm._v("Where is here? I don’t see you.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("C:")]), _vm._v(" "), _c('td', [_vm._v("I am here.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("S:")]), _vm._v(" "), _c('td', [_vm._v("I am getting unpleased.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("C:")]), _vm._v(" "), _c('td', [_vm._v("I am sorry, Senor.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("S:")]), _vm._v(" "), _c('td', [_vm._v("Again I ask: Where is here?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("C:")]), _vm._v(" "), _c('td', [_vm._v("I am under your shoe, Senor.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("S:")]), _vm._v(" "), _c('td', [_vm._v("How did you get there, Chullo?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("C:")]), _vm._v(" "), _c('td', [_vm._v("I was not looking where I was going and you were talking to the pretty senorita.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("S:")]), _vm._v(" "), _c('td', [_vm._v("I thought I stepped on a piece of gum. You must look where you are going, Chullo.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("C:")]), _vm._v(" "), _c('td', [_vm._v("I have many sorrows, Senor.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("S:")]), _vm._v(" "), _c('td', [_vm._v("You are forgiven. Now, pick yourself up and let us go.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("C:")]), _vm._v(" "), _c('td', [_vm._v("Yes, Senor.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcfcf944","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0009.vue
// module id = 96
// module chunks = 0